import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
  Navigate,
} from "react-router-dom";

import AuthProvider, { useAuth } from "./context/AuthProvider";
import LangProvider from "./context/LangProvider";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import Signout from "./pages/Signout";
import MyPage from "./pages/MyPage";
import ModalProvider from "./modal/ModalProvider";

import "./App.css";
import FindAccount from "./pages/FindAccount";
import { LoadingElement } from "./helpers/utils";
import DropoutPage from "./pages/Dropout";
import ExistingAccount from "./pages/ExistingAccount";
import AccountDeletion from "./pages/AccountDeletion";

export function RequireAuth({ redirect = "/" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingElement />; // 로딩 UI 원하면 여기서 렌더
  if (!user)
    return <Navigate to={redirect} replace state={{ from: location }} />;
  return <Outlet />; // 보호된 라우트 렌더
}

export function GuestOnly({ redirect = "/my-page", children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingElement />;
  if (user) return <Navigate to={redirect} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* 비로그인 전용 화면 */}
      <Route
        path="/"
        element={
          <GuestOnly>
            <Signin />
          </GuestOnly>
        }
      />
      <Route path="/signout" element={<Signout />} />
      <Route path="/account-deletion" element={<AccountDeletion />} />
      <Route
        path="/signup"
        element={
          <GuestOnly>
            <Signup />
          </GuestOnly>
        }
      />
      <Route
        path="/find-account"
        element={
          <GuestOnly>
            <FindAccount />
          </GuestOnly>
        }
      />
      <Route
        path="/existing-account"
        element={
          <GuestOnly>
            <ExistingAccount />
          </GuestOnly>
        }
      />
      <Route element={<RequireAuth redirect="/" />}>
        <Route path="/my-page" element={<MyPage />} />
        <Route path="/drop-out" element={<DropoutPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LangProvider>
        <ModalProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ModalProvider>
      </LangProvider>
    </AuthProvider>
  );
}
